<template>
  <ml-input v-if="readonly" v-model="data" style="color: red" readonly class="w-full flex-1" />
  <div v-else-if="multiple">
    <div style="display: grid; grid-template-columns: auto 1fr;">
      <vs-checkbox v-model="isFrequency">빈도순</vs-checkbox>
      <multiselect :options="disasterList" v-model="data" :multiple="true" placeholder="" @input="onInputMultiItem"/>
    </div>
    <ml-input v-if="isCustomData" v-model="customData" class="mt-2 w-full" placeholder="직접입력" />
  </div>
  <div v-else>
    <div class="w-full red-text disaster" >

      <vs-select v-model="data" autocomplete :disabled="disabled || readonly" class="w-full red-text disaster" @change="onChangeItem">
        <vs-select-item v-for="disaster in disasterList" :key="disaster" :value="disaster" :text="disaster" />
      </vs-select>
      <vs-checkbox class="mt-2" v-model="isFrequency">빈도순</vs-checkbox>
    </div>
    <ml-input v-if="isCustomData" v-model="customData" @focusout="focusout" class="mt-2 w-full" placeholder="직접입력" />
  </div>
</template>

<script>
import { disasters } from "@/util/DisasterDataUtil.js";
import Multiselect from "vue-multiselect";
import HttpRequest from '@/util/HttpRequest'
export default {
  name: "DisasterClassSelector",
  components: {
    Multiselect,
  },
  props: {
    value: String | Array,
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
  },
  computed: {
    isCustomData() {
      return this.data && this.data.indexOf("직접입력") >= 0;
    },
    disasterList () {
      const newData = JSON.parse(JSON.stringify(disasters.sort()))

      if (this.isFrequency) {
        for (const check of this.orderData) {
          const index = newData.indexOf(check)
          if (index > 0) {
            newData.splice(index, 1)
          }
        }
        const merged = [...this.orderData, ...newData];

        // 중복 항목을 제거하고 반환한다
        return merged.filter((item, index) => merged.indexOf(item) === index)
      }
      return newData
    }
  },
  data() {
    return {
      isFrequency: true,
      orderData : [],
      oldData: this.value,
      data: this.value,
      customData: "",
      selected: "",
    };
  },
  watch: {
    value(value) {
      if (this.multiple) {
        const list = [];
        if (value && value.length > 0) {
          for (const data of value) {
            if (disasters.indexOf(data) === -1) {
              list.push("직접입력");
              this.customData = data;
            } else {
              list.push(data);
            }
          }
        }
        if (JSON.stringify(this.data) !== JSON.stringify(list)) {
          this.data = list;
        }
      } else {
        this.data = value;
      }
    },
    customData() {
      this.emitInput();
    },
    data() {
      this.emitInput();
    },
  },
  created() {
    this.loadList();
  },
  mounted() {},
  methods: {
    loadList () {
      HttpRequest.get('/api/v1/info/disaster/order').then(response => {
        this.orderData = [...response.disaster_names];
      }).catch(err => {
        console.log(err)
      })
    },
    setData (disaster) {
      if (disaster) {
        const option = {
          params: {
            disaster_name: disaster
          }
        }
        HttpRequest.post('/api/v1/info/disaster/record', option.params)
          .then(response => {
            this.loadList();
          }).catch(err => {  })
      }
    },
    focusout() {
      this.$emit("input", this.customData);
    },
    emitInput() {
      if (!this.multiple) {
        // if (this.data === "직접입력") {
        //   this.$emit("input", this.customData);
        // } else {
        //   this.$emit("input", this.data);
        // }
        this.$emit("input", this.data);
      } else {
        const list = [];
        if (this.data && this.data.length > 0) {
          for (const data of this.data) {
            if (data === "직접입력") {
              list.push(this.customData);
            } else {
              list.push(data);
            }
          }
        }
        this.$emit("input", list);
      }
    },

    onChangeItem (item) {
      this.setData(item)
    },

    onInputMultiItem (item) {
      if (this.oldData.toString() !== item.toString()) {
        if (typeof item === 'string') {
          this.setData(item)
        } else if (typeof item === 'object' && item.length > 0) {
          for (const it of item) {
            if (this.oldData.length === 0) {
              this.oldData = []
            }
            if (this.oldData.indexOf(it) < 0) {
              this.setData(it)
            }
          }
        }
      }

      this.oldData = JSON.parse(JSON.stringify(item))
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.red-text.disaster input {
  color: red;
}
</style>
<style lang="scss">
.multiselect {
  .multiselect__tags {
    .multiselect__tag {
      background-color: rgba(var(--vs-secondary), 1) !important;
    }
    .multiselect__tag-icon::after {
      color: rgb(30, 13, 97);
    }
    border-color: #cdcdcd !important;
  }
}
</style>
